<main class="main">
    <app-header></app-header>
    <div class="page">
        <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
</main>